import React from 'react';
import { PageHeader } from '@/ui/PageHeader';
import { NotesBoard } from '@/components/NotesBoard';

const STATUS_OPTIONS = ['idea', 'drafting', 'scheduled', 'posted'];

export function SocialMediaScreen() {
  return (
    <div className="admin-page max-w-3xl mx-auto">
      <PageHeader
        title="Social Media"
        subtitle="Content planning board — ideas through posted, one card per post/campaign."
      />
      <NotesBoard
        page="social_media"
        statusOptions={STATUS_OPTIONS}
        newButtonLabel="Add post idea"
        emptyTitle="No content planned yet"
        emptyHint="Add the first post idea or campaign note above."
      />
    </div>
  );
}
